import React from 'react';
import ItemList from '../../../components/item-list/ItemList';

const CarriersTable = ({
  carriers,
  selectedCarriers,
  onSelectAll,
  onSelectCarrier,
  onToggleExpand,
  onDeleteSelected,
  onEdit,
  onViewFiles,
  onChangeStatus,
  canSelect = true,
  canDelete = true,
  canEdit = true,
  canChangeStatus = true,
  currentPage,
  onPageChange,
  totalItems,
  itemsPerPage = 10,
  isServerPaginated = true,
  loading = false
}) => {
  const columns = [
    { key: 'name', label: 'Company Name' },
    { key: 'dba', label: 'DBA' },
    { key: 'mc', label: 'MC#' },
    { key: 'dot', label: 'DOT#' },
    { key: 'location', label: 'Location' },
    { key: 'status', label: 'Status' },
    { key: 'actions', label: 'Action' }
  ];

  return (
    <ItemList
      items={carriers}
      itemType="carriers"
      selectedItems={selectedCarriers}
      onSelectAll={onSelectAll}
      onSelectItem={onSelectCarrier}
      onToggleExpand={onToggleExpand}
      onDeleteSelected={onDeleteSelected}
      onEdit={onEdit}
      onViewFiles={onViewFiles}
      onChangeStatus={onChangeStatus}
      canSelect={canSelect}
      canDelete={canDelete}
      canEdit={canEdit}
      canChangeStatus={canChangeStatus}
      currentPage={currentPage}
      onPageChange={onPageChange}
      columns={columns}
      totalItems={totalItems}
      itemsPerPage={itemsPerPage}
      isServerPaginated={isServerPaginated}
      loading={loading}
    />
  );
};

export default CarriersTable;

